import { Divider, styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  padding: theme.spacing(0, 3),
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    borderRadius: theme.spacing(3),
    overflow: 'hidden',
    padding: theme.spacing(0, 3, 10, 3),
  },
}));

export const Inner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
  boxSizing: 'border-box',
  padding: theme.spacing(0, 0, 3, 0),
  [theme.breakpoints.up('md')]: {
    maxHeight: '100%',
    padding: theme.spacing(6, 3, 0, 3),
  },
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(6),
    padding: theme.spacing(6, 7, 0, 7),
  },
}));

export const Suggestions = styled('div')(({ theme }) => ({
  display: 'flex',
  overflowX: 'auto',
  flexWrap: 'nowrap',
  scrollbarWidth: 'none',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(3),
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'wrap',
    overflowX: 'visible',
  },
}));

export const Products = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const SeeAllResults = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: '0',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(3, 0),
  left: 0,
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  margin: theme.spacing(3, 0),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(1, 0),
  },
}));
